export default {
  palette: ['#CC9FFF', '#FFE34C', '#4365A8', '#FF7979', '#444444'],
  series: [
    {
      name: 'Em Andamento',
      valueField: 'Em Andamento',
      argumentField: 'label',
    },
    {
      name: 'Pausadas',
      valueField: 'Pausadas',
      argumentField: 'label',
    },
    {
      name: 'Programadas',
      valueField: 'Programadas',
      argumentField: 'label',
    },
    {
      name: 'Atrasadas',
      valueField: 'Atrasadas',
      argumentField: 'label',
    },
    {
      name: 'Canceladas',
      valueField: 'Canceladas',
      argumentField: 'label',
    },
  ],
};
